import Vuex from "vuex";
import Vue from "vue";
import datasets from "./modules/datasets";
import map from "./modules/map";
// import compositeDataset from "./modules/compositeDataset";

// Load Vuex
Vue.use(Vuex);

// Create store
export default new Vuex.Store({
  modules: {
    datasets,
    map
  }
});
